// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__sBlhd","calendarButtons":"ClockData_calendarButtons__1fz7H"};